import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "dsp-popover-content"
};
const _hoisted_5 = {
  class: "title-and-value"
};
const _hoisted_6 = {
  class: "details"
};
const _hoisted_7 = {
  class: "detail-title-and-value-container"
};
const _hoisted_8 = {
  class: "detail-title-and-value"
};
const _hoisted_9 = {
  class: "detail-title"
};
const _hoisted_10 = {
  class: "detail-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_product_table_total = _resolveComponent("product-table-total");
  const _component_text_value = _resolveComponent("text-value");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "DSP Consolidation",
    class: "overview-table",
    noDownload: "",
    fields: $data.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector")]),
    default: _withCtx(() => [_createVNode(_component_b_table_lite, {
      class: "lite-table lite-table-hoverable period-table overview-table",
      fields: $data.fields,
      bordered: "",
      responsive: "",
      fixed: "",
      items: $options.items.filter(item => item?.goal !== 'Total'),
      "sticky-header": true,
      tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
      "no-border-collapse": "",
      onRowClicked: $options.handleRowClick
    }, {
      "head(dsp_overview_campaign_goal)": _withCtx(col => [_createElementVNode("div", {
        innerHTML: col?.label,
        class: "title"
      }, null, 8, _hoisted_1)]),
      "head()": _withCtx(col => [_createVNode(_component_flex_row, {
        id: `default-period-table-${col?.column}`,
        styles: {
          justifyContent: col.field.justify,
          ...col.field.thStyle
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          target: `default-period-table-${col?.column}`
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
          }, null, 8, _hoisted_2)]),
          content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
          default: _withCtx(() => [_createElementVNode("div", {
            innerHTML: col?.column === 'period_agg' ? _ctx.getPeriodColumnTitle : col?.label,
            class: "title"
          }, null, 8, _hoisted_3)]),
          _: 2
        }, 1032, ["target"])]),
        _: 2
      }, 1032, ["id", "styles"])]),
      "custom-foot": _withCtx(() => [_createElementVNode("tr", null, [_createVNode(_component_product_table_total, {
        fields: $data.fields,
        total: $options.items.filter(item => item?.goal === 'Total')?.[0],
        currencyConfig: _ctx.currencyConfig,
        loading: $props.loading
      }, null, 8, ["fields", "total", "currencyConfig", "loading"])])]),
      "cell(dsp_overview_campaign_goal)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_text_value, {
          value: row.item?.goal,
          color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
        }, null, 8, ["value", "color"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_budget)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.budget_share,
          background: "",
          borderColor: "#FFE8DB",
          min: 0,
          max: 1,
          loading: $props.loading,
          align: "left",
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#FFE8DB'
          },
          style: {
            "flex": "1 0 0"
          },
          tight: "",
          styles: {
            width: '100%',
            borderRadius: '6px',
            background: '#FAFAFA'
          },
          class: "dsp-overview-overlap-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            styles: {
              justifyContent: 'space-between',
              width: '100%'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.budget_share,
              charCount: $options.maxCharCount?.percentage?.budget_share
            }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
              valueAlign: "right",
              value: row.item?.budget,
              charCount: $options.maxCharCount?.currency?.budget,
              color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
            }, null, 8, ["value", "charCount", "color"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["value", "loading"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_spend)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.spend_share,
          background: "",
          borderColor: "#FFE8DB",
          min: 0,
          max: 1,
          loading: $props.loading,
          align: "left",
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#FFE8DB'
          },
          style: {
            "flex": "1 0 0"
          },
          tight: "",
          styles: {
            width: '100%',
            borderRadius: '6px',
            background: '#FAFAFA'
          },
          class: "dsp-overview-overlap-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            styles: {
              justifyContent: 'space-between',
              width: '100%'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.spend_share,
              charCount: $options.maxCharCount?.percentage?.spend_share
            }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
              valueAlign: "right",
              value: row.item?.spend,
              charCount: $options.maxCharCount?.currency?.spend,
              color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
            }, null, 8, ["value", "charCount", "color"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["value", "loading"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_delivery_rate)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.delivery_rate,
          color: $options.getColorsBasedOnRange(row.item?.delivery_rate, $data.DSP_DELIVERY_RATE_COLORS),
          styles: {
            background: $options.getColorsBasedOnRange(row.item?.delivery_rate, $data.DSP_DELIVERY_RATE_BG_COLORS),
            padding: '1px 8px',
            borderRadius: '6px'
          }
        }, null, 8, ["value", "color", "styles"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_objective)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          delay: {
            show: 0,
            hide: 100
          },
          target: `dsp_overview_objective_${row.item?.goal}`,
          width: 230,
          padding: "8px",
          class: "raos_vs_target_popover",
          customClass: "dsp-popover"
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            styles: {
              justifyContent: 'space-between',
              width: '100%'
            },
            id: `dsp_overview_objective_${row.item?.goal}`
          }, {
            default: _withCtx(() => [_createVNode(_component_flex_row, {
              styles: {
                flex: '1 0 0'
              },
              gap: 8
            }, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent({
                'Repurchases': 'CoinsSwapIcon',
                'New Customers': 'UserPlusIcon',
                'Consideration Signals': 'rssIcon',
                'Reach': 'AnnoncementIconSmall'
              }[row.item?.objective_type]), {
                color: row.item?.budget === null ? '#BDBDBD' : {
                  'Repurchases': '#8E3D0B',
                  'New Customers': '#F27123',
                  'Consideration Signals': '#FCAF83',
                  'Reach': '#d9c6ba'
                }[row.item?.objective_type],
                width: 12,
                height: 12
              }, null, 8, ["color"])), _createVNode(_component_text_value, {
                value: row.item?.objective_type,
                color: row.item?.budget === null ? '#BDBDBD' : {
                  'Repurchases': '#8E3D0B',
                  'New Customers': '#F27123',
                  'Consideration Signals': '#FCAF83',
                  'Reach': '#d9c6ba'
                }[row.item?.objective_type],
                styles: {
                  textAlign: 'left'
                }
              }, null, 8, ["value", "color"])]),
              _: 2
            }, 1024), _createVNode(_component_currency_value, {
              value: row.item?.objective_value,
              showSymbol: false
            }, null, 8, ["value"])]),
            _: 2
          }, 1032, ["id"])]),
          _: 2
        }, [row.item?.objective_type !== 'Reach' ? {
          name: "content",
          fn: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(row.item?.objective_type) + " ", 1), _createVNode(_component_currency_value, {
            value: Math.sumPrecise($options.getBreakdownPerGoal(row.item?.objective_type)?.map(elt => row.item?.[elt] ?? 0)),
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: Math.max(...$options.getBreakdownPerGoal(row.item?.objective_type)?.map(elt => $options.maxCharCount?.number?.[elt] ?? 0))
          }, null, 8, ["value", "loading", "charCount"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_bar_with_value, {
            value: row.item?.breakdown_a,
            min: Math.min(Math.sumPrecise($options.getBreakdownPerGoal(row.item?.objective_type)?.map(elt => $options.minMax?.[elt]?.min ?? 0)), $options.minMax?.breakdown_a?.min),
            color: "#F89053",
            max: Math.sumPrecise($options.getBreakdownPerGoal(row.item?.objective_type)?.map(elt => $options.minMax?.[elt]?.max ?? 0)),
            loading: $props.loading,
            height: 15,
            tight: "",
            style: {
              "width": "100%"
            }
          }, {
            "bar-append": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getBreakdownPerGoal(row.item?.objective_type)?.slice(1), (elt, idx) => {
              return _openBlock(), _createElementBlock("div", {
                class: "bar-background",
                style: _normalizeStyle({
                  width: `${row.item?.[elt] / Math.sumPrecise($options.getBreakdownPerGoal(row.item?.objective_type)?.map(elt => $options.minMax?.[elt]?.max ?? 0)) * 100 ?? 0}%`,
                  borderRadius: idx === $options.getBreakdownPerGoal(row.item?.objective_type)?.slice(1)?.length - 1 ? '0 4px 4px 0' : '0',
                  height: '15px',
                  background: `${{
                    breakdown_b: '#FCAF83',
                    breakdown_c: '#FFCCAD',
                    breakdown_d: '#FFE9DB'
                  }[elt]}`
                })
              }, null, 4);
            }), 256))]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getBreakdownPerGoal(row.item?.objective_type), elt => {
            return _openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_dot_element, {
              color: `${{
                breakdown_a: '#F89053',
                breakdown_b: '#FCAF83',
                breakdown_c: '#FFCCAD',
                breakdown_d: '#FFE9DB'
              }[elt]}`,
              size: 8
            }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString({
              'Repurchases': {
                'breakdown_a': 'SnS',
                'breakdown_b': 'Single purchase'
              },
              'New Customers': {
                'breakdown_a': 'SnS',
                'breakdown_b': 'Single purchase'
              },
              'Consideration Signals': {
                'breakdown_a': 'ATC Clicks',
                'breakdown_b': 'DPV Clicks',
                'breakdown_c': 'ATC Views',
                'breakdown_d': 'DPV Views'
              }
            }[row.item?.objective_type]?.[elt] ?? ''), 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_currency_value, {
              value: row.item?.[elt],
              loading: $props.loading,
              showSymbol: false,
              align: "right",
              allowPrecisionModification: false,
              charCount: $options.maxCharCount?.currency?.[elt],
              precision: row.item?.[elt] > 1000000 ? 1 : 0
            }, null, 8, ["value", "loading", "charCount", "precision"])])]);
          }), 256))])])])]),
          key: "0"
        } : undefined]), 1032, ["target"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_cpa)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          valueAlign: "right",
          value: row.item?.cpa,
          precision: 2,
          charCount: $options.maxCharCount?.currency?.cpa + 2,
          color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
        }, null, 8, ["value", "charCount", "color"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_optimization_kpi)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_flex_row, {
          gap: 12,
          styles: {
            justifyContent: 'space-between',
            width: '100%'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_text_value, {
            value: row.item?.optimization_type,
            styles: {
              textAlign: 'left'
            },
            color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
          }, null, 8, ["value", "color"]), row.item?.optimization_type === 'DPVR' ? (_openBlock(), _createBlock(_component_percentage_value, {
            key: 0,
            value: row.item?.optimization_value,
            color: row.item?.budget === null ? '#fff' : row.item?.optimization_value >= row.item?.optimization_target ? '#22863D' : '#FFF0F1',
            styles: {
              background: row.item?.budget === null ? '#bdbdbd' : row.item?.optimization_value >= row.item?.optimization_target ? '#DEFBE6' : '#DB333B',
              padding: '1px 8px',
              borderRadius: '6px'
            }
          }, null, 8, ["value", "color", "styles"])) : _createCommentVNode("", true), row.item?.optimization_type === 'ROAS' ? (_openBlock(), _createBlock(_component_currency_value, {
            key: 1,
            value: row.item?.optimization_value,
            color: row.item?.budget === null ? 'f#ff' : row.item?.optimization_value >= row.item?.optimization_target ? '#22863D' : '#FFF0F1',
            styles: {
              background: row.item?.budget === null ? '#bdbdbd' : row.item?.optimization_value >= row.item?.optimization_target ? '#DEFBE6' : '#DB333B',
              padding: '1px 8px',
              borderRadius: '6px'
            },
            precision: 2,
            showSymbol: false
          }, null, 8, ["value", "color", "styles"])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_assisted_sales)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.assisted_sales_share,
          background: "",
          borderColor: "#D0E2FF",
          min: 0,
          max: 1,
          loading: $props.loading,
          align: "left",
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#D0E2FF'
          },
          style: {
            "flex": "1 0 0"
          },
          tight: "",
          styles: {
            width: '100%',
            borderRadius: '6px',
            background: '#FAFAFA'
          },
          class: "dsp-overview-overlap-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            styles: {
              justifyContent: 'space-between',
              width: '100%'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.assisted_sales_share,
              charCount: $options.maxCharCount?.percentage?.assisted_sales_share
            }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
              valueAlign: "right",
              value: row.item?.assisted_sales,
              charCount: $options.maxCharCount?.currency?.assisted_sales,
              color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
            }, null, 8, ["value", "charCount", "color"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["value", "loading"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_overview_assisted_units_sold)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.units_sold_share,
          background: "",
          borderColor: "#D0E2FF",
          min: 0,
          max: 1,
          loading: $props.loading,
          align: "left",
          barStyles: {
            borderLeft: 'none',
            borderRadius: '4px',
            height: '22px',
            background: '#D0E2FF'
          },
          style: {
            "flex": "1 0 0"
          },
          tight: "",
          styles: {
            width: '100%',
            borderRadius: '6px',
            background: '#FAFAFA'
          },
          class: "dsp-overview-overlap-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_flex_row, {
            styles: {
              justifyContent: 'space-between',
              width: '100%'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.units_sold_share,
              charCount: $options.maxCharCount?.percentage?.units_sold_share
            }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
              valueAlign: "right",
              showSymbol: false,
              value: row.item?.units_sold,
              charCount: $options.maxCharCount?.currency?.units_sold,
              color: row.item?.budget === null ? '#bdbdbd' : '#4D4D4D'
            }, null, 8, ["value", "charCount", "color"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["value", "loading"])]),
        _: 2
      }, 1032, ["loading"])]),
      _: 1
    }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
    _: 3
  }, 8, ["fields", "loading"]);
}